<template>
  <div class="m-header">
    <div class="m-header-left">
      <div style="width: 70px; height: 70px;display: flex;flex-wrap: wrap;align-items: center;justify-content: center;margin: 5px 0 0 5px;">
        <img src="../../assets/img/logo.jpg" style="width: 100%;" alt=""/>
      </div>
      <div style="height: 70px;width: 450px;display: flex;flex-wrap: wrap;align-items: center;margin: 0 0 0 15px;">
        <div style="color: #9e0c0c;font-size: 22px;height: 35px;font-weight: bold;padding-top: 5px;">
          北京六十甲子系统科学研究院有限公司
        </div>
      </div>
    </div>
    <div class="m-header-right" style="width: 100%;">
      <div style="display: flex;padding-right: 20px;">
        <div v-for="item in options" :key="item.type" @click="toPage(item.type)" class="m-header-options"
             :class="item.type === optionIndex ? 'is-Selected' : ''">
          <div>{{item.title}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      optionIndex: '',
      options: [
        {type: 'home', title: '首页'},
        {type: 'subclassListInfo', title: '商品信息'},
        {type: 'ziXun', title: '行业资讯'},
        {type: 'ruZhu', title: '商家入驻'},
        {type: 'login', title: '个人中心'},
        {type: 'login1', title: '商家管理中心'},
        {type: 'jianJie', title: '院况简介'},
        {type: 'jiGou', title: '组织机构'}
      ]
    }
  },
  methods: {
    toPage (path) {
      this.$router.push({name: path})
    }
  },
  mounted () {
    let type = this.$route.name
    if (type !== undefined && type !== '') {
      if (type === 'home' || type === 'subclass') {
        this.optionIndex = 'home'
      } else if (type === 'ziXun' || type === 'subclassZiXun') {
        this.optionIndex = 'ziXun'
      } else if (type === 'ruZhu') {
        this.optionIndex = 'ruZhu'
      } else if (type === 'jiGou') {
        this.optionIndex = 'jiGou'
      } else if (type === 'jianJie') {
        this.optionIndex = 'jianJie'
      } else if (type === 'login') {
        this.optionIndex = 'login'
      } else if (type === 'login1') {
        this.optionIndex = 'login1'
      } else if (type === 'subclassListInfo') {
        this.optionIndex = 'subclassListInfo'
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/public/Header.vue